<template>
  <com-header :actived="2"></com-header>
  <div class="eBusiness-container inner-container">
    <inner-banner
      :img="bannerImg"
      title="预约管理系统"
      brief="预约管理系统提供SaaS+智慧预约体系。场馆管理方可自定义场馆预约规则，入场表单个性化设计，电子票核销等，快速完成移动互联。用户可通过系统查询场馆使用情况，经统一账户在线预定场馆，轻松体验OTO生活"
    ></inner-banner>
    <com-title class="mt-20" title="产品优势"></com-title>
    <div class="advantage-box mt-20">
      <div class="common-container flex justify-between">
        <div class="advantage-item wow bounceInUpSlow" data-wow-delay="0.1s">
          <icon-card class="yellow-org" :img="img1" title="快速部署" brief="技术平台标准功能模块化产品，灵活配置，快速构建业务服务与应用"></icon-card>
        </div>
        <div class="advantage-item wow bounceInUpSlow" data-wow-delay="0.2s">
          <icon-card class="yellow-org" :img="img1" title="智能管理" brief="提供智能管理后台，随时管理场馆资源"></icon-card>
        </div>

        <div class="advantage-item wow bounceInUpSlow" data-wow-delay="0.3s">
          <icon-card class="yellow-org" :img="img1" title="一体化服务" brief="提供从场馆预约设置至电子票核销全流程服务"></icon-card>
        </div>
        <div class="advantage-item wow bounceInUpSlow" data-wow-delay="0.4s">
          <icon-card class="yellow-org" :img="img1" title="灵活定制" brief="可根据使用场景提供UI定制服务"></icon-card>
        </div>
      </div>
    </div>

    <div class="yinyong-box mt-20">
      <div class="common-container">
        <com-title title="应用场景"></com-title>
        <ul class="mt-6">
          <li>
适用于大中型体育场馆、篮羽足网球馆、游泳馆、瑜伽馆、舞蹈培训等运动健身机构，以及各类纪念场馆、社区共享资源等需要进行分时段控制入场人次的场合。</li>
        </ul>
      </div>
    </div>
    <div class="case-box">
      <div class="common-container">
        <com-title title="客户案例"></com-title>
        <div class="case-list flex justify-between">
          <div class="case-item  wow  bounceInUpSlow"      data-wow-delay="0.1s">
            <img src="@/assets/images/other/order-case01.jpeg" alt />
          </div>
          <div class="case-item  wow  bounceInUpSlow"   data-wow-delay="0.15s">
            <img src="@/assets/images/other/order-case02.jpeg" alt />
          </div>
          <div class="case-item  wow  bounceInUpSlow"  data-wow-delay="0.2s">
            <img src="@/assets/images/other/order-case03.jpeg" alt />
          </div>
          <div class="case-item  wow  bounceInUpSlow"  data-wow-delay="0.25s">
            <img src="@/assets/images/other/order-case04.jpeg" alt />
          </div>
        </div>
      </div>
    </div>
  </div>
  <com-footer></com-footer>
</template>
<script setup>
  import { Navigation,Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import bannerImg from '@/assets/images/product-banner.png'
import { ref } from 'vue'
import img1 from '@/assets/images/power-img01.png'
import img2 from '@/assets/images/power-img02.png'
import img3 from '@/assets/images/power-img03.png'
import img4 from '@/assets/images/power-img04.png'

const onSwiper = (swiper) => {
  // console.log(swiper);
};
const onSlideChange = () => {
  // console.log('slide change');
};
const modules = ref([Navigation,Pagination])
</script>
<style  >
/* @import "@/assets/style/inner.less"; */
</style>